import { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { useStepSelfieStyleContext } from 'inquiry/context/StepSelfieStyleContext';
import { colorCss } from 'lib/inquiryStyles';

const SelfieRight1: FC<{ frames?: number }> = () => {
  const { startIcon } = useStepSelfieStyleContext() ?? {};
  const theme = useContext(ThemeContext);

  const fillColor = colorCss(startIcon?.['fill-color']?.base.base) ?? theme.iconColorPrimary;
  const fillColorHighlight =
    colorCss(startIcon?.['fill-color']?.highlight.base) ?? theme.iconColorHighlight;
  const strokeColor = colorCss(startIcon?.['stroke-color']?.base.base) ?? theme.iconColorStroke;

  return (
    <svg role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 227.3 227.3' aria-label='right'>
      <path fill='none' d='M-3-3h233.3v233.3H-3z' />
      <path
        d='M143.9 187.5c.6-7.6-1.7-18.7 9.1-21.7 0 .1-.1.1-.1.1l15-2.7v-18.6c.5-20.9 1.2-52.1 1.2-52.1s1.9-11.2.9-22.8c-.9-11-6.7-20.7-6.7-20.7-.4-9.3-2.2-16.3-10-24.9-7.6-8.3-17.8-11.4-28.8-13.5-12-2.3-22.9-.8-34.3 3.4-9.5 3.5-17.1 8-24 15.4-5.8 6.3-13 21-13 21v.2c-9 9.5-13.8 27.6-13.7 41.6.2 13.8-.3 64.2 3.1 70.9 2 3.9 35.2 4 36.5 3.8 5.1 2.1 5.3 6.6 3.8 16.7-14 .4-45.8 9.3-45.8 9.3 13.6 13.2 45.2 31.1 77.3 31.1 27.3 0 51.8-7.9 69.5-23.4 0-.2-26.2-11.3-40-13.1z'
        fill={fillColor}
      />
      <path
        d='M99.4 58.9c-9.2.1-18.5 2.5-25.4 8.5-7.7 6.6-11.9 17-11.4 27.1-5.3-.4-9.8 4.9-10 10.3-.3 11.3 8.5 17 8.9 17.9.5 1 3.9 20.3 8.8 31.3 2.4 5.3 7.3 15 12.5 17.1l.6 15.6 1.1 1c17.2 14.8 42.8 14.4 59.5-1v-14c4.5-3.5 8.8-7.5 16.7-17.2 4.6-5.6 7.8-20.2 7.6-27.5-.2-7.2-.2-15.2-.4-22.4-.4-14.9.7-32.1-8-45-3.6 3.3-11.6 9.9-22.6 10.4-15.6.7-31.2-12.1-37.9-12.1z'
        fill={fillColorHighlight}
      />
      <path
        d='M121.7 149.4l5.9 1.8c2.7.8 5.6 1.1 8.4.8s5.6-1.2 8.1-2.6m-5.5-21.8c-1.2-8.3-1.6-16.7-1.1-25m-75.1-6.4c-2.1-15 9.5-27.6 17.4-32.4 7.3-4.4 18.6-6.6 26.8-3.6 5.3 1.9 9.8 5.6 15 7.6 9.3 3.7 20.5 3.4 29.8-.4 10.4-4.3 13.2-18.5 11.7-24.7-2.3-9.5-6.2-15.4-11.5-20.2-7.8-7.1-16.3-10-27-11.9-11.6-2.1-23.2-.5-34.3 3.4-9.2 3.2-17.6 8.3-24 15.4-10.3 11.3-14 23.5-13.9 35.5m116.3 33.8s-.6 9.5.3 23.3c.7 12-2.3 25.6-9.8 35.6-6.5 8.7-16.3 17.7-26.1 22.5-17.8 8.8-40.4-.7-56.9-14.8M55.6 46.4c-9.1 9.5-16.4 32.2-16.2 48.5-1 30.6 1.9 63.9 3.2 68.1 4.3 1.8 24.4 4.8 35 3.4-11.5-15.8-16-44.2-15.9-44m8.6-17.3c-1-2-1.9-4-3.3-5.7s-3.3-3.1-5.5-3.4c-3.9-.6-7.6 2.5-8.8 6.3-1.1 3.7-.2 7.9 1.6 11.3 2.6 5.2 7 9.4 12.2 11.9m93.6-66.3c6.2 9.2 9.1 29.5 8.6 39.5 5.2-14.2 1.3-38.1-5-51.9M83.4 171.6v16.2l1.1.9c8.3 6.9 19 10.6 30 10.4 11-.2 21.6-4.2 29.6-11.3v-14.9m-60.7 10.5c-13.3 0-26.5 1.9-39.2 5.6L30 193.1m114.2-9.6c13.3 0 25.8 1.8 38.5 5.5l14.2 4.1m-27.8-63.8c-.2 11.2 0 33.4-.3 33.9s-11.8 2.8-16.5 2.6'
        fill='none'
        stroke={strokeColor}
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <linearGradient
        id='right1_svg__a'
        gradientUnits='userSpaceOnUse'
        x1='113.65'
        y1='6732.6'
        x2='113.65'
        y2='6750.276'
        gradientTransform='translate(0 -6621)'
      >
        <stop offset='.52' stopColor={strokeColor} stopOpacity='0' />
        <stop offset='1' stopColor={strokeColor} stopOpacity='.3' />
      </linearGradient>
      <path
        d='M227.3 118.3s-55-6.7-113.6-6.7S0 119 0 119s28.3 10.3 113.9 10.3c78.6 0 113.4-11 113.4-11'
        fill='url(#right1_svg__a)'
      />
      <linearGradient
        id='right1_svg__b'
        gradientUnits='userSpaceOnUse'
        x1='4672.472'
        y1='-188.98'
        x2='4672.472'
        y2='-219.041'
        gradientTransform='rotate(90 2239.37 -2319.45)'
      >
        <stop offset='.001' stopColor={strokeColor} stopOpacity='0' />
        <stop offset='1' stopColor={strokeColor} stopOpacity='.3' />
      </linearGradient>
      <path
        d='M110.7 227.3S139 192.5 139 114c0-85.6-28.1-114-28.1-114s-2 55.1-2 113.7 1.8 113.6 1.8 113.6'
        fill='url(#right1_svg__b)'
      />
    </svg>
  );
};

export default SelfieRight1;
